import { jsx as _jsx } from "react/jsx-runtime";
import { mdiFilterPlusOutline } from '@mdi/js';
import { defineMessage } from 'react-intl';
import { defineStyle } from '../../theme';
import { FilterButton } from './FilterButton';
const filterTooltip = {
    id: 'tableFiltering.addFilter.tooltip',
    defaultMessage: 'Add a filter clause',
};
const addFilterStyle = defineStyle({
    textTransform: 'capitalize',
});
const andText = defineMessage({
    id: 'common.and',
    defaultMessage: 'Add AND group',
});
const addFilterText = defineMessage({
    id: 'tableFiltering.addFilter.button',
    defaultMessage: 'Add filter',
});
const defaultAppendValue = [
    {
        orConditions: [
            {
                field: '',
                operator: undefined,
                value: undefined,
            },
        ],
    },
];
export default function AddAndFilterButton({ append, fieldsCount, onOpenAddFilterDialog, disabled, }) {
    const isEmpty = fieldsCount === 0;
    const openDialog = isEmpty && onOpenAddFilterDialog;
    const handleAddCustom = () => {
        if (openDialog) {
            onOpenAddFilterDialog();
        }
        else {
            append(defaultAppendValue);
        }
    };
    return (_jsx(FilterButton, { icon: mdiFilterPlusOutline, tooltip: filterTooltip, text: isEmpty ? addFilterText : andText, sxAdditions: isEmpty ? addFilterStyle : undefined, variant: "outlined", size: "small", color: "primary", disabled: disabled, onClick: handleAddCustom }));
}
//# sourceMappingURL=AddAndFilterButton.js.map